import type User from '@this/src/domain/user/user';
import React from 'react';

interface Context {
  serviceId: number;
  env: string;
  user: User | null;
  availableOptions: string[];
}

const CoreAppContext = React.createContext<Context>({ serviceId: 1, env: '', user: null, availableOptions: [] });
export default CoreAppContext;
